import { Decoder, Encoder } from '#common/util/text-encode-decode';
export function createTextEncoder() {
    return new Encoder();
}
export function createTextDecoder() {
    return new Decoder();
}
